import { render, staticRenderFns } from "./ReferralsForm.vue?vue&type=template&id=21e9a470"
import script from "./ReferralsForm.vue?vue&type=script&lang=js"
export * from "./ReferralsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports